import { render, staticRenderFns } from "./DoctorInput.vue?vue&type=template&id=3442dfc3&scoped=true&"
import script from "./DoctorInput.vue?vue&type=script&lang=js&"
export * from "./DoctorInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3442dfc3",
  null
  
)

export default component.exports